/**
 * A class to store a password reset
 */
export class PasswordReset {
  /**
   * @param token - The password reset token
   * @param userId - The ID of the user requesting the password reset
   * @param newPassword - The user's new password
   */
  constructor(
    public token: string,
    public userId: string,
    public newPassword: string
  ) {}
}
